import { ApplicationModes } from '../../../common/constants/application-modes';
import { servePromptOfTheDayExperiment } from '../../../common/utils/experiments';

// Rovo chat is where the prompt is sent: the row needs Rovo mode and Rovo AI (isRovoLLMEnabled).
// Which products get it is the experiment's targeting, not a list here.
export const isPromptOfTheDayEligible: (
	applicationMode: ApplicationModes | undefined,
	isRovoLLMEnabled: boolean,
) => boolean = (applicationMode, isRovoLLMEnabled) =>
	applicationMode === ApplicationModes.Rovo && isRovoLLMEnabled;

// Reads the experiment value without exposure; usePromptOfTheDayExposure fires it from the pre-query list.
export const isPromptOfTheDayEnabled: (
	applicationMode: ApplicationModes | undefined,
	isRovoLLMEnabled: boolean,
) => boolean = (applicationMode, isRovoLLMEnabled) =>
	isPromptOfTheDayEligible(applicationMode, isRovoLLMEnabled) && servePromptOfTheDayExperiment();
